module.exports = __webpack_public_path__ + "img/th.221f5a96.svg";